<template>
  <div>
    <div
      :class="['wrapper', enableSlider ? '' : 'wrapper--hidden']"
      data-hero-image
      :style="{
        opacity: opHand,
        transform: `translateY(${(120 * (delta))}%)`,
      }"
      ref="wrapper"
    ></div>
    <Hero />
    <Arrows
      :style="{
        display: op === 0 ? 'none' : 'inline-block',
        opacity: op,
        transform: `translateY(${(100 * (delta))}%)`
      }"
      :class="[isSafari() ? $style.fixSafari : false]"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Hammer from 'hammerjs'

import { isSafari, lerp } from '@/scripts/utils'
import loop from '@/scripts/loop'

import Hero from '@/components/Hero'
import Arrows from '@/components/Arrows'
import EventBus from '@/scripts/event-bus'
import * as Trail from '@/scripts/Trail'
import Hand from '@/scripts/hand'

export default {
  components: {
    Arrows,
    Hero
  },

  data() {
    return {
      hand: null,
      trail: null,
      isSafari,
    }
  },

  computed: {
    ...mapState(['enableSlider']),

    ...mapGetters(['getScrollbar']),

    delta() {
      let res = 0

      if (this.getScrollbar) {
        const scrollTop = this.getScrollbar.scrollTop
        res = Math.min((scrollTop / window.innerHeight), 1.2)
      }

      return res
    },

    op() {
      let op = 1

      if (this.getScrollbar) {
        const scrollTop = this.getScrollbar.scrollTop
        op = Math.max(0, (1 - (scrollTop / 200)))
      }


      return op
    },

    opHand() {
      let op = 1

      if (this.getScrollbar) {
        const scrollTop = this.getScrollbar.scrollTop
        op = Math.max(0, (1 - (scrollTop / (window.innerHeight / 1.5))))
      }


      return op
    }
  },

  mounted() {
    this.hm = new Hammer.Manager(this.$el)
    const swipe = new Hammer.Swipe({
      direction: Hammer.DIRECTION_HORIZONTAL
    })
    this.hm.add(swipe)
    this.hm.on('swipeleft', () => { EventBus.$emit('swipedLeft') })
    this.hm.on('swiperight', () => { EventBus.$emit('swipedRight') })

    this.init()
  },

  methods: {
    init() {
      this.initTrail(this.$refs.wrapper)
      this.initHand(this.$refs.wrapper)
      this.addEvents();

      loop.add(this.update, 'hand_handler')
      this.resize()

      // setTimeout(() => this.triggerRandomLight(), 300);
    },

    initTrail(ctx) {
      const options = {
        touchDevice: false,
        container: ctx
      }

      this.trail = new Trail.default(options)
      this.trail.start()

      this.trail.colorA = 0x2ce5c4
      this.trail.colorB = 0xf400dc

      this.trail.bloomStrength = 1.6
      this.trail.bloomRadius = 0.12

      this.trail.frequency = 20
      this.trail.bounceAmplitude = 0.03
      this.trail.bounceRange = 0.14

      this.trail.frequency2 = 8.6
      this.trail.amplitude = 4.9
      this.trail.amplitude2 = 11.1
      this.trail.lightLength = 4
      this.trail.lightSpeed = 2

      this.trail.globalSpeed = 1.2
      this.trail.scaleY = 0.2

      // this.initHand(this.$refs.hand)
    },

    initHand(ctx) {
      this.hand = new Hand(ctx, {
        cameraZ: 720,
        cameraZMobile: 800,
        geometryYMobile: 100,
        geometryY: 60,
        layerYMobile: 110,
        layerY: 0,
        parallaxFactorX: 56,
        parallaxFactorY: 38
      })
    },

    addEvents() {
      EventBus.$on('triggerRandomLight', this.triggerRandomLight.bind(this));
      EventBus.$on('slideHand', this.slideHand.bind(this));
      EventBus.$on('windowResize', this.resize.bind(this));
    },

    update() {
      this.trail.update()
      this.hand.update()
    },

    triggerRandomLight() {
      if (this.trail !== null) this.trail.triggerLight(this.getRandomColor(), this.getRandomColor())
    },

    slideHand(event) {
      if (this.hand !== null) this.hand.slide(event.direction, event.currentHand, event.fromMenu)
    },

    getRandomColor() {
      const letters = '0123456789ABCDEF'
      let color = '0x'

      for (let i = 0; i < 6; i += 1) {
        color += letters[Math.floor(Math.random() * 16)]
      }

      return color
    },

    resize() {
      this.trail.resize()
      this.hand.resize()
    }
  },

  beforeDestroy() {
    loop.remove('hand_handler')
  }
}
</script>

<style lang="scss">
.wrapper {
  & canvas:first-child {
    z-index: 0;
  }
  & canvas:last-child {
    z-index: 1;
  }
}
</style>

<style lang="scss" module>
@import "~sass-mq/mq";

.fixSafari {
  @include mq($until: sm) {
    & > div {
      bottom: 74px;
    }
  }

  @include mq($until: sm, $and: $is-iphonex) {
    & > div {
      bottom: 110px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CanvasHero.vue